import { SwiperOptions } from 'swiper';
import { Product } from "../../../../shared/models/product";
import { Component, OnInit, OnDestroy, AfterViewChecked, ViewChild, HostListener } from "@angular/core";
import {Location} from '@angular/common';
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "src/app/shared/services/toastr.service";
import { ProductsService } from "src/app/services/products.service";
@Component({
  selector: "app-product-detail",
  templateUrl: "./product-detail.component.html",
  styleUrls: ["./product-detail.component.scss"],
})
export class ProductDetailComponent implements OnInit, OnDestroy, AfterViewChecked {
  @ViewChild("WraperSameHeight") wraperSameHeight: any;
  private sub: any;
  product: any;
  innerHeight: number;
  config: SwiperOptions = {
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 10,
    // Disable preloading of all images
    preloadImages: false,
    // Enable lazy loading
    lazy: true,
    loop: true,
   
  };
  constructor(
    private route: ActivatedRoute,
    private productsService: ProductsService,
    private location : Location ,
  ) {
  }
  ngAfterViewChecked(): void {
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      const id = params.id; // (+) converts string 'id' to a number
      this.getProductDetail(id);
    });
  }

  getProductDetail(id: string) {
    this.productsService.getProduct(id).subscribe((result: any) => {
      this.product = result;
      this.product.productAttachments = result.productAttachments.filter(x => x.fileType === 'image' || x.fileType === 'mainimage');
     
    });
  }

  // addToCart(product: Product) {
  //   this.productService.addToCart(product);
  // }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  back() {
    this.location.back();
  }
}
